// extracted by mini-css-extract-plugin
export default {"container":"card_container__p6JFf","productsPage":"card_productsPage__AHOWA"};